'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { api } from '~/libs/api';
import type { LoyaltyCustomer } from '~/services/loyalty';
import { RewardsTierBanner } from './RewardsTierBanner';
import { REWARDS_TIERS } from './RewardsTiers.config';
interface RewardsTierBannerLiveProps {
  readonly initialCustomer: LoyaltyCustomer | null;
}
export const RewardsTierBannerLive = t0 => {
  const $ = _c(12);
  const {
    initialCustomer
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== initialCustomer) {
    t1 = {
      initialData: initialCustomer,
      staleTime: 0,
      refetchOnWindowFocus: true
    };
    $[0] = initialCustomer;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: customer
  } = api.account.loyaltyStatus.useQuery(undefined, t1);
  const {
    data: bookedTrips
  } = api.account.bookedTrips.useQuery();
  const reconciledTierRef = useRef(null);
  let t2;
  if ($[2] !== router) {
    t2 = {
      onSuccess: result => {
        if (result.changed) {
          router.refresh();
        }
      }
    };
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutate: reconcile
  } = api.account.reconcileLoyalty.useMutation(t2);
  const sessionTierId = initialCustomer?.tierId ?? null;
  const liveTierId = customer?.tierId ?? null;
  let t3;
  let t4;
  if ($[4] !== liveTierId || $[5] !== reconcile || $[6] !== sessionTierId) {
    t3 = () => {
      if (liveTierId === null || liveTierId === sessionTierId || reconciledTierRef.current === liveTierId) {
        return;
      }
      reconciledTierRef.current = liveTierId;
      reconcile();
    };
    t4 = [liveTierId, sessionTierId, reconcile];
    $[4] = liveTierId;
    $[5] = reconcile;
    $[6] = sessionTierId;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  const isOnRewardTier = customer != null && REWARDS_TIERS.some(tier => tier.tierId === customer.tierId);
  if (!isOnRewardTier || !customer) {
    return null;
  }
  const t5 = bookedTrips?.length;
  let t6;
  if ($[9] !== customer || $[10] !== t5) {
    t6 = <div className="mb-8"><RewardsTierBanner customer={customer} tripsBooked={t5} /></div>;
    $[9] = customer;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};